import i18n from 'i18next';
// import productPropertiesOverlay from './de/productPropertiesOverlay.json';
// import ns2 from './en/ns2.json';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import createEntryPoint from '../..';

i18n.use(HttpApi)
    .use(initReactI18next)

let url;

try {
    url = (document.querySelectorAll('[data-fs-resources]')[0] as HTMLElement).dataset.fsResources;
} catch (error) {
    console.log(error);
}

i18n.init({
    compatibilityJSON: 'v3',
    ns: [
        'productPropertiesOverlay'
    ],
    defaultNS: 'productPropertiesOverlay',
    backend: {
        loadPath: url || '/jportal/nav/juris-shop-pwa/fs-ressourcen.json'
    },
    debug: false,
    lng: 'de',
    fallbackLng: 'de',
}).then(() => {
    createEntryPoint('[product_properties_overlay]', 'productOverlayButton');
    createEntryPoint('#product_cart_page', 'productCartPage');
    // createEntryPoint('#campaign_order_button', 'campaignOrder');
    createEntryPoint('#multi-test-form-page', 'multiTestFormPage');
});

export default i18n;